
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/materials",
      function () {
        return require("private-next-pages/materials/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/materials"])
      });
    }
  